// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * @package    block_quickmail
 * @copyright  2008 onwards Louisiana State University
 * @copyright  2008 onwards Chad Mazilly, Robert Russo, Jason Peak, Dave Elliott, Adam Zapletal, Philip Cali, David Lowe
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

define(['jquery'], function($) {
    let addBtn = $('#id_add_recip');
    let removeBtn = $('#id_remove_recip');
    let availablesSelect = $('#id_available_included_entity_ids');
    let selectedsSelect = $('#id_selected_included_entity_ids');

    let syncSelected = function() {
        $('[name="included_entity_ids"]').val('');

        let entities = [];
        $('#id_selected_included_entity_ids option').each(function() {
            entities.push($(this).val());
        });

        $('[name="included_entity_ids"]').val(entities);
    };

    return {
        init: function() {
            addBtn.click(function() {
                $('#id_available_included_entity_ids option:selected').remove().appendTo(selectedsSelect);
                $('#id_selected_included_entity_ids option:selected').prop('selected', false);
                syncSelected();
            });

            removeBtn.click(function() {
                $('#id_selected_included_entity_ids option:selected').remove().appendTo(availablesSelect);
                $('#id_available_included_entity_ids option:selected').prop('selected', false);
                syncSelected();
            });
        }
    };
});
